import { useMutation, useQueryClient } from '@tanstack/react-query';
import { QueryKey } from 'api/model';
import { toast } from 'react-toastify';
import { errorHandler } from 'api/axios_instance';
import { deactivateUser, reactivateUser } from './requests';

const useUser = (userId: string) => {
  const queryClient = useQueryClient();

  const invalidate = () => {
    void queryClient.invalidateQueries({ queryKey: [QueryKey.Users] });
  };

  const deactivate = useMutation({
    mutationFn: () => deactivateUser(userId),
    onSuccess: (user) => {
      invalidate();
      toast.success(`User ${user.username} deactivated`);
    },
    onError: errorHandler('Deactivating user failed'),
  });

  const reactivate = useMutation({
    mutationFn: () => reactivateUser(userId),
    onSuccess: (user) => {
      invalidate();
      toast.success(`User ${user.username} reactivated`);
    },
    onError: errorHandler('Reactivating user failed'),
  });

  return { deactivate, reactivate };
};

export default useUser;
